import React, { Component } from 'react';
import { connect } from 'react-redux';
import GoalList from '../../components/Student/GoalList';
import { getStudentGoals, getStudent, fetchUserGoalDatabanks, fetchMyGoals, updateStudentDefaultManaged } from '../../../redux/actions';
import {
  Dialog,
  DialogContent,
  Divider,
  Typography,
  Button,
  DialogActions,
  Switch,
  FormControlLabel,
  Grid,
  Card,
  CardContent,
  CircularProgress
} from '@material-ui/core/index';
import { CheckCircleOutlined } from '@material-ui/icons/index';
import GoalWizard from '../../components/Wizards/Goal/GoalWizardBase';
import { withStyles } from '@material-ui/core/styles/index';
import baseStyle from '../../../styles/goals.js';
import ImportGoal from '../../components/Staff/ImportGoal';
import { FormattedMessage } from 'react-intl';

class Goals extends Component {

  state = {
    open: false,
    goal: false,
    isToggling: false
  };

  componentDidMount() {
    this.props.getStudentGoals(this.props.id);
    this.props.getStudent(this.props.id);
    this.props.fetchUserGoalDatabanks();
    this.props.fetchMyGoals();
    if (this.props.history.location.search){
      this.setState({ open: true })
    }
  }

  handleDefaultManagedToggle = async () => {
    const { student } = this.props;
    if (!student || !student.id || this.state.isToggling) return;
    
    const newValue = student.isDefaultManaged === 'Y' ? 'N' : 'Y';
    
    // Set loading state and change cursor to spinning
    this.setState({ isToggling: true });
    document.body.style.cursor = 'wait';
    
    try {
      await this.props.updateStudentDefaultManaged(student.id, newValue);
      // Refresh goals after the API call completes
      await this.props.getStudentGoals(this.props.id);
    } catch (error) {
      console.error('Error updating default managed status:', error);
    } finally {
      // Reset loading state and cursor
      this.setState({ isToggling: false });
      document.body.style.cursor = 'default';
    }
  };

  render() {
    const { classes, student } = this.props;
    const { isToggling } = this.state;
    
    // Handle case where student data hasn't loaded yet
    if (!student || !student.id) {
      return (
        <div>
          <Typography variant='h3'>Loading...</Typography>
        </div>
      );
    }
    
    const isDefaultManaged = student.isDefaultManaged === 'Y';
    
    return (
      <div>
        <div className={classes.title}>
          <CheckCircleOutlined className={classes.icon} fontSize='inherit'/>
          <Typography className={classes.text} variant='h3'>
            {student.firstName}'s <FormattedMessage id='Goals.title'/>
          </Typography>
        </div>
        <Divider />
        <br />
        
        <Grid container alignItems="center" spacing={2} style={{ marginBottom: '20px', maxWidth: '100%', overflow: 'hidden', paddingLeft: '20px' }}>
          <Grid item xs="auto">
            <FormControlLabel
              control={
                <Switch
                  checked={isDefaultManaged}
                  onChange={this.handleDefaultManagedToggle}
                  color="primary"
                  disabled={isToggling}
                />
              }
              label="Using ObjectiveEd Managed Goals"
            />
          </Grid>
          {isToggling && (
            <Grid item xs="auto">
              <CircularProgress size={20} />
            </Grid>
          )}
        </Grid>
        
        {isDefaultManaged ? (
          <Card>
            <CardContent>
              <Typography variant="h6" align="center" color="textSecondary">
                This student is using ObjectiveEd managed goals. Toggle the switch above to view and manage custom goals.
              </Typography>
            </CardContent>
          </Card>
        ) : (
          <>
            <GoalList skill={this.props.skillDatabank} clickable deletable editable type={this.props.history.location.search === '?guided' ? 'guidedGoal' : 'goal'} {...this.props}/>
            <div className={classes.skillBtns}>
              <GoalWizard guided={this.props.history.location.search === '?guided'} open={this.state.goal} id={this.props.id} history={this.props.history} />
              <ImportGoal title={<FormattedMessage id='Databanks.importGoal' />} history={this.props.history} id={this.props.id}/>
            </div>
          </>
        )}
        
        <Dialog open={this.state.open}>
          <DialogContent>
            <Typography variant='h6' align='center'>
              {
                this.props.goals && this.props.goals.length > 0
                ? "Please Select which goal you want to put this skill under"
                : "It looks like there are no goals, let's add one!"
              }
            </Typography>
            <DialogActions>
              <Button onClick={() => this.setState({ open: false, goal: this.props.goals && this.props.goals.length <= 0  })}>
                OK
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </div>
    )
  }
}

const mapState = ({ platform: { goals, student, skillDatabank }}) => {
  return {
    goals,
    student,
    skillDatabank
  }
};

const mapDispatch = (dispatch, {history}) => {
  return {
    getStudentGoals: (studentId) => dispatch(getStudentGoals(studentId, history)),
    getStudent: (studentId) => dispatch(getStudent(studentId)),
    fetchUserGoalDatabanks: () => dispatch(fetchUserGoalDatabanks(history)),
    fetchMyGoals: () => dispatch(fetchMyGoals()),
    updateStudentDefaultManaged: (studentId, isDefaultManaged) => dispatch(updateStudentDefaultManaged(studentId, isDefaultManaged)),
  }
};

export default connect(mapState, mapDispatch)(withStyles(baseStyle)(Goals));